import { reatomAsync, withDataAtom } from '@reatom/async';
import { atom } from '@reatom/framework';
import { withLocalStorage } from '@reatom/persist-web-storage';
import { BACKEND_API } from '@trwl/backend.api';

export const getBalanceAction = reatomAsync(async () => {
  return BACKEND_API.BonusesApi.getBalance().then((r) => r.data);
}, 'getBalanceAction').pipe(withDataAtom(null));

getBalanceAction.dataAtom.pipe(withLocalStorage('balanceAtom'));

export const isBalanceLoadingAtom = atom(
  (ctx) => ctx.spy(getBalanceAction.pendingAtom) > 0,
  'isBalanceLoadingAtom',
);
